export default "__VITE_ASSET__881c4ee8__"